import { PatientCareServiceId } from '@app/icare/entities/patient/schema/PatientCareService'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientCareServiceOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_careService/-components/PatientCareServiceOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_careService/pflegedienste/$relation')({
  params: entityParams({ id: PatientId, relation: PatientCareServiceId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientCareServiceOverview patientId={id} relationId={relation} />
}
